import { render, staticRenderFns } from "./subTopNav.vue?vue&type=template&id=71b86334&"
import script from "./subTopNav.vue.ts?vue&type=script&lang=ts&"
export * from "./subTopNav.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports